import React, { useState } from "react";
import "./WeeklyProblems.css";
import { test } from "../../../Status";
import { Link, Links, useNavigate } from "react-router-dom";
import ProblemSet from "./Components/ProblemSet/ProblemSet";
import Leaderboard from "./Components/Leaderboard";
import StudentsSubmissions from "./Components/StudentsSubmissions";
import CorrectionUpdates from "./Components/CorrectionUpdates/CorrectionUpdates";
import { archiveData } from "../../../Status";
const WeeklyProblems = () => {
  const navigate = useNavigate();
  const [ActiveTab, setActiveTab] = useState("ProblemSet");
  const Position = test.role;
  

  const renderTable = () => {
    switch (ActiveTab) {
      case "ProblemSet":
        return <ProblemSet />;
      case "CorrectUpdates":
        return <CorrectionUpdates />;
      case "StudentsSubmissions":
        return <StudentsSubmissions archiveData={archiveData} />;
      case "LeaderBoard":
        return <Leaderboard archiveData={archiveData} />;

      default:
        return null;
    }
  };
  return (
    <div className="Problem-table-container">
      <h1>📚 Weekly Problem </h1>

      <p className="Purpose">
        <b>Puropose : </b>The Weekly Problem section is one of the core pillars
        of MathTounsi, created to provide a regular and structured way for
        students across Tunisia to engage with rich, challenging math problems —
        just like those encountered in Olympiads.
        <br /> On weekly bases, a set of 4 problems would be posted for you to
        solve. After submitting your solution you would be assigned a score out
        of 7.
        <br /> At the end of each month, a mathematician of the month would be
        annouced and would gain a permanent badge.
        <br /> We recommand at least finishing this set of reading : The two
        first units of Geometry, Combinatorics, Algebra and Number Theory. Go to{" "}
        <Link to="/resources">units</Link>.
      </p>

      {/* <p>Let \((a_n)_{n\in\mathbb{N}}  \)</p> */}

      <div className="Archive-buttons">
        <button
          className={ActiveTab === "ProblemSet" ? "active" : ""}
          onClick={() => setActiveTab("ProblemSet")}
        >
          Problem Sets
        </button>
        {/* {Position === "Admin" ? (
          <button
            className={ActiveTab === "StudentsSubmissions" ? "active" : ""}
            onClick={() => setActiveTab("StudentsSubmissions")}
          >
            Students Submissions
          </button>
        ) : (
          <button
            className={ActiveTab === "CorrectUpdates" ? "active" : ""}
            onClick={() => setActiveTab("CorrectUpdates")}
          >
            Correction Updates
          </button>
        )} */}
        <button
          className={ActiveTab === "LeaderBoard" ? "active" : ""}
          onClick={() => setActiveTab("LeaderBoard")}
        >
          Live Leaderboard
        </button>
      </div>

      <div className="render">{renderTable()}</div>
    </div>
  );
};

export default WeeklyProblems;
